var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var HeaderGeneratorInteractionModel = require('./headerGeneratorInteractionModel.js');

var HeaderStraightGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    HeaderGeneratorInteractionModel.apply(this, arguments);

    this.terminalTailLength = this.shadow("terminalTailLength",
        function() {
            return this.data.terminalTailLength() / this.getUnitFactor();
        },
        function(value) {
            return this.data.terminalTailLength(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.terminalTailLength, this.userSettingsModel.distanceUnit
        ]
    );
};

lib_core.inherit(HeaderStraightGeneratorInteractionModel, HeaderGeneratorInteractionModel);
HeaderStraightGeneratorInteractionModel.$class = 'HeaderStraightGeneratorInteractionModel';
module.exports = HeaderStraightGeneratorInteractionModel;

HeaderStraightGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

HeaderStraightGeneratorInteractionModel.prototype.getInspectorElementForBodyHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('bodyHeight', 'Body Height'), false, this.bodyHeightMin, false, this.bodyHeightMax, this.userSettingsModel.distanceUnit)];
};
